<!-- <nav>
  <a routerLink="/dashboard">Dashboard</a> <br>
  <a routerLink="/pos">Heroes</a>
</nav> -->
<div class="container-fluid pt-4">
  <router-outlet></router-outlet>
  <app-dashboard></app-dashboard>
</div>
